<template>
  <section>
    <housemaid-policy-detail-info
      v-if="productId == 12"
      :showAmount="showAmount"
      :formData="formData"/>
    <decoration-policy-detail-info
      v-else-if="productId == 15"
      :showAmount="showAmount"
      :formData="formData"/>
    <working-policy-detail-info
      v-else-if="productId == 13"
      :showAmount="showAmount"
      :formData="formData"/>
    <travel-policy-detail-info
      v-else-if="productId == 14"
      :showAmount="showAmount"
      :formData="formData"/>
    <student-policy-detail-info
      v-else-if="productId == 16"
      :showAmount="showAmount"
      :formData="formData"/>
    <homefire-policy-detail-info
      v-else-if="productId == 17"
      :showAmount="showAmount"
      :formData="formData"/>
    <personal-policy-detail-info
      v-else-if="productId == 18"
      :showAmount="showAmount"
      :formData="formData"/>
    <fire-policy-detail-info
      v-else-if="productId == 20"
      :showAmount="showAmount"
      :formData="formData"/>
    <template v-else-if="productId==80">
      <sme-policy-detail-info
        v-if="!isNewSME"
        :form-data="formData"></sme-policy-detail-info>
      <sme-kyc-info
        v-else
        is-policy
        is-detail
        :form-data="formData"
      ></sme-kyc-info>
    </template>

    <template v-else>
      <div class="table">
        <div class="tr">
          <span>Insured Period</span>
          <span >{{ formData.insurance_period}}</span>
        </div>
        <div class="tr">
          <span>Expected Insured Period</span>
          <span >
            {{ formData.period_date }}
            <span
              v-if="formData.is_eff_dt_delay && formData.pcy_stts != 425"
              class="asap">(ASAP)</span>
          </span>
        </div>
        <div class="tr">
          <span>Total Price</span>
          <span
            v-if="showAmount"
          >{{ showAmount | formatMoney(2, true) }}</span>
        </div>
        <div class="tr">
          <span>Referrer</span>
          <span class="flex-column">
            <span
              class="referrer"
            >{{referrer.isrd_lst_nm}} {{referrer.isrd_fst_nm}}</span>
            <div class="tags">
              <span
                v-if="referrer.is_tier_base"
                class="span-status blue">
                Professional
              </span>
              <span
                v-if="referrer.verify_language"
                class="span-status"
                :class="{
                  'verified': referrer.verified == 20,
                  'pending_verify ': referrer.verified == -1,
                  'not_verify': referrer.verified == -2
                }">
                {{ referrer.verify_language }}
              </span>
              <span
                v-if="customer_profile.is_flagged"
                class="span-status flag">
                Flagged
              </span>
            </div>
          </span>
        </div>
        <div
          v-if="formData.discount_str"
          class="tr">
          <span>Referrer Discount</span>
          <span>{{formData.discount_str}}</span>
        </div>
        <div
          v-if="!isEndorse"
          class="tr">
          <span>Policy Number </span>
          <span >{{ formData.pcy_no  }}</span>
        </div>
        <div
          v-else
          class="tr">
          <span>Endorsement Number </span>
          <span >{{ formData.endorser_no  }}</span>
        </div>
        <div class="tr">
          <span>Cover Note Number</span>
          <span>{{ formData.cvr_nt_no }}</span>
        </div>
        <div class="tr">
          <span>Policy Reference Code </span>
          <span >{{ formData.order_sn }}</span>
        </div>
        <template v-if="formData.class_id !== 14">
          <div class="tr">
            <span>Insurance Type</span>
            <span >{{ getOptionName('coverTypeOptions', formData.trm_of_cvr) }}</span>
          </div>
          <div
            v-if="formData.trm_of_cvr != 1"
            class="tr">
            <span>Sum Insured</span>
            <span  >{{ formData.isrd_vl | formatMoney(2, true) }}</span>
          </div>
          <div
            v-if="formData.trm_of_cvr != 1"
            class="tr">
            <span>Hire Purchase Owner</span>
            <span >{{ getOptionName('yesNoOptions', formData.hp_ind) }}</span>
          </div>
          <div
            v-if="formData.trm_of_cvr != 1 && formData.hp_ind == 1"
            class="tr">
            <span>Name of Hire Purchase Owner (If Yes for Hire purchase)</span>
            <span
              v-if="!isMortgagorOther"
            >{{ getLocalAllOptionName('mortgagor', formData.mortgagor)}}</span>
            <span
              v-else
            >{{  formData.mortgagor_other}}</span>
          </div>
        </template>
        <div
          v-if="option_benefits.length>0"
          class="tr">
          <span>Optional Benefits</span>
          <span>
            <span
              v-for="(item,index) in option_benefits"
              :key="'extra'+index">{{item.item}}<br></span>
          </span>
        </div>
        <div
          v-if="formData.class_id==11&&extraBenefitSelect.length>0"
          class="tr">
          <span>Extra Benefits</span>
          <span>
            <template v-for="(item,index) in extraBenefitSelect">
              <span
                v-if="Array.isArray(formData.extra_benefits) && formData.extra_benefits.includes(item.id)"
                :key="'extra'+index">{{item.name}}<br></span>
            </template>
          </span>
        </div>
        <template
          v-if="extra_content_pcy.length>0"
        >
          <div
            v-for="(item,index) in extra_content_pcy"
            :key="'pcy'+index"
            class="tr">
            <span>
              {{item.name}} Policy No.
            </span>
            <span>{{item.pcy_no}}</span>
          </div>
        </template>
      </div>
      <div class="box">
        <h3>Excess</h3>
        <div class="table">
          <div class="tr th">
            <span>Item</span>
            <span>Amount</span>
          </div>
          <div
            v-for="(inItem, index) in excessList"
            :key="index + inItem.premium"
            class="tr">
            <span>{{ inItem.item }}</span>
            <span>{{ inItem.premium }}</span>
          </div>
          <div class="tr">
            <span>Excess Remark</span>
            <span
              v-html="changeLineData(formData.quote_remark)"></span>
          </div>
        </div>
      </div>
      <div class="box">
        <div
          v-for="(excessItem, excessIndex) in coverageList.items"
          :key="'coverage' + excessIndex">
          <div
            v-if="excessItem.sub_items.length>0"
            class="table">
            <h3 :class="{'table-title':excessIndex>0}">{{ excessItem.sub_title? excessItem.sub_title: coverageList.title }}</h3>
            <div
              v-if="excessIndex==0"
              class="tr th">
              <span>Item</span>
              <span>Information</span>
            </div>
            <div
              v-for="(subItem, subIndex) in excessItem.sub_items"
              :key="'coverage-' + excessIndex + subIndex"
              class="tr">
              <span>{{ subItem.item }}</span>
              <span>{{ subItem.premium }}</span>
            </div>
            <div class="tr">
              <span>Coverage Remark</span>
              <span
                v-html="changeLineData(formData.cvr_remark)"></span>
            </div>
          </div>
        </div>
        <template v-if="extra_content_premium.length>0">
          <h3 class="extra-title">Extra Benefits</h3>
          <div
            v-for="(excessItem, excessIndex) in extra_content_premium"
            :key="'ext' + excessIndex">
            <div
              class="table">
              <div
                class="tr ">
                <span>{{excessItem.name}}</span>
              </div>
              <div
                class="tr ">
                <span>coverage</span>
              </div>
              <div
                v-for="(subItem, subIndex) in excessItem.content.coverage"
                :key="'coverage-extra' + excessIndex + subIndex"
                class="tr">
                <span>{{ subItem.name }}</span>
                <span>{{ subItem.money }}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div
        v-if="specialList.length>0"
        class="box">
        <h3>{{specialData.title}}</h3>
        <div class="table">
          <div
            v-for="(inItem, index) in specialList"
            :key="index + inItem.key"
            class="tr">
            <span>{{ inItem.val }}</span>
          </div>
        </div>
      </div>
      <div class="box">
        <h3>Policyholder</h3>
        <policy-holder-info
          :form="formData"
          :compareList="compareList"/>
      </div>
      <div class="box">
        <!--            <h3>Insured Vehicle</h3>-->
        <h3 v-if="formData.class_id == 14">Insured Motorcycle Details</h3>
        <h3 v-if="formData.class_id == 11">Insured Private Details</h3>
        <h3 v-if="formData.class_id == 12">Insured Commercial Vehicle Details</h3>

        <insured-vehicle-info
          :form="formData"
          :compareList="compareList"/>
      </div>
      <div class="box">
        <h3>Insured Driver(s)</h3>
        <drivers-info
          :form="formData"
        />
      </div>
      <div class="box">
        <h3>Remark(s)</h3>
        <div class="table strip">
          <div class="tr">
            <span>Remark</span>
            <span v-html="changeLineData(formData.cs_manual_remark)"></span>
          </div>
        </div>
      </div>
    </template>
    <template v-if="!isNewSME">
      <template>
        <!-- no endorsement -->
        <template  v-if="!showEndorsementPremium">
          <div
            v-if="productId!=80"
            class="box">
            <div class="flex flex-aglin-icon">
              <h3>Premium</h3>
            <!--            <font-awesome-icon-->
            <!--              class="icon"-->
            <!--              icon="info-circle"-->
            <!--              @click="handleShowPremium()"></font-awesome-icon>-->
            </div>
            <div class="table">
              <div class="tr th">
                <span>Item</span>
                <span>Amount</span>
              </div>
              <div
                v-for="(item,index) in sidebarPremium"
                :key="'sude'+index"
                class="tr">
                <template v-if="item.item == 'MGM Discount'">
                  <span>
                    <div class="flex ">
                      <span v-html="changeLineData(item.item)"></span>
                      <span
                        v-if="formData.code"
                        class="mg-l-8">{{formData.code}}</span>
                    </div>
                  </span>
                  <span>{{ item.premium_str }}</span>
                </template>
                <template v-else>
                  <span v-html="changeLineData(item.item)"></span>
                  <span>{{ item.premium_str }}</span>
                </template>
              </div>
            </div>
          </div>
          <section
            v-else
            class="sme-container__info">
            <div
              class="box">
              <div class="table">
                <div class="th">
                  <div class="flex flex-aglin-icon">
                    <span class="fw-600">Premium</span>
                  <!--                  <font-awesome-icon-->
                  <!--                    class="icon"-->
                  <!--                    icon="info-circle"-->
                  <!--                    @click="handleShowPremium()"></font-awesome-icon>-->
                  </div>
                </div>
                <div
                  v-for="(item,index) in sidebarPremium"
                  :key="'sude'+index"
                  class="tr">
                  <span
                    class="fw-600"
                    v-html="changeLineData(item.item)"></span>
                  <span>{{ item.premium_str }}</span>
                </div>
              </div>
            </div>
          </section>
        </template>
        <div
          v-else
          class="box">
          <div class="flex flex-aglin-icon">
            <h3>{{isEndorse?'Endorsement':'Adjustment'}} Premium</h3>
          <!--          <font-awesome-icon-->
          <!--            class="icon"-->
          <!--            icon="info-circle"-->
          <!--            @click="handleShowPremium()"></font-awesome-icon>-->
          </div>
          <span
            v-if="productId!==11"
            class="sub-title">Difference Payable</span>
          <div class="table">
            <div class="tr th">
              <span>Item</span>
              <!--                  <span>Percentage</span>-->
              <span>Amount</span>
            </div>
            <div
              v-for="(item,index) in sidebarPremium"
              :key="'sude'+index"
              class="tr">
              <span>{{item.item}}</span>
              <span>{{ item.premium_str }}</span>
            </div>
          </div>
        </div>
      </template>
      <div class="box">
        <h3>Direct Marketing Consent</h3>
        <div class="table strip">
          <div class="tr">
            <span>Marketing Consent</span>
            <span
              v-if="formData.marketing_data"
              class="marketing">
              {{getOptionName('consentOptions',formData.marketing_data.is_use)}}
              <template v-if="!formData.marketing_data.is_use">
                <div
                  v-if="Array.isArray(formData.marketing_data.use_data)"
                  class="op">
                  <p
                    v-for="(item, i) in marketingList"
                    :key="i">
                    {{item.name}}: {{getOptionName('consentOptions',formData.marketing_data.use_data.includes(item.id)?1:0)}}
                  </p>
                </div>
                <p>Data-sharing: {{getOptionName('consentOptions',formData.marketing_data.other_use)}}</p>
              </template>
            </span>
          </div>
        </div>
      </div>
      <div class="box">
        <h3>Signature</h3>
        <div class="sign_pic">
          <img :src="sign_pic"/>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
import SmePolicyDetailInfo from '@/views/records/policy/modules/sme/sme-policy-detail-info'
import InsuredVehicleInfo from '@/views/components/insured-vehicle-info'
import PolicyHolderInfo from '@/views/tickets/components/info/policy-holder-info'
import DriversInfo from '@/views/tickets/components/info/drivers-info'
import HousemaidPolicyDetailInfo from '@/views/records/policy/modules/housemaid/housemaid-policy-detail-info'
import DecorationPolicyDetailInfo from '@/views/records/policy/modules/decoration/decoration-policy-detail-info'
import HomefirePolicyDetailInfo from '@/views/records/policy/modules/homefire/homefire-policy-detail-info'
import TravelPolicyDetailInfo from '@/views/records/policy/modules/travel/travel-policy-detail-info'
import StudentPolicyDetailInfo from '@/views/records/policy/modules/student/student-policy-detail-info'
import WorkingPolicyDetailInfo from '@/views/records/policy/modules/working/working-policy-detail-info'
import PersonalPolicyDetailInfo from '@/views/records/policy/modules/personal/personal-policy-detail-info'
import firePolicyDetailInfo from '@/views/records/policy/modules/homefire/fire-policy-detail-info'
import MixinFormat from '@/mixins/format'
import MixinOptions from '@/mixins/options'
import SmeKycInfo from '@/views/sme/components/kycInfo'

export default {
  name: 'policy-detail',
  components: {
    SmePolicyDetailInfo,
    InsuredVehicleInfo,
    PolicyHolderInfo,
    DriversInfo,
    HousemaidPolicyDetailInfo,
    DecorationPolicyDetailInfo,
    HomefirePolicyDetailInfo,
    TravelPolicyDetailInfo,
    StudentPolicyDetailInfo,
    WorkingPolicyDetailInfo,
    PersonalPolicyDetailInfo,
    firePolicyDetailInfo,
    SmeKycInfo
  },
  mixins: [MixinFormat, MixinOptions],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    inter: {
      type: Boolean,
      default: false  //  控制是否顯示内部文件
    },
    customer: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      formData: {
        code_disc_prm: '',
        code_disc_pct: ''
      },
      marketingList:[]
    }
  },
  computed:{
    isNewSME(){
      let {sme_versions} = this.$route.query||{}
      return sme_versions==3
    },
    customer_profile(){
      return this.customer||{}
    },
    referrer(){
      let {referrer} = this.formData||{}
      return referrer||{}
    },
    productId() {
      return this.form.product_id || null
    },
    currentOrderId() {
      return this.formData.id
    },
    isEndorse(){
      return [30,40].includes(this.formData.type)
    },
    showEndorsementPremium() {
      const {type} = this.formData
      return [30, 40, 50].includes(type)
    },
    allBenefitsList() {
      if (this.classId == 14) return []
      return this[`allOptions${this.classId}`].benefits || []
    },
    recordList() {
      // 可能要改一下
      if (!this.form.record) return []
      return this.form.record.reduce((result, item) => {
        result.push({
          ...item,
          open: false
        })
        return result
      }, [])
    },
    excessList(){
      let {quote_coverage_list} = this.formData||{}
      let {excess} = quote_coverage_list||{}
      let {items} = excess||{}
      if(items){
        return items[0].sub_items
      }
      return  []
    },
    coverageList(){
      let {quote_coverage_list} = this.formData||{}
      let {coverage={}} = quote_coverage_list||{}
      return  coverage
    },
    extraBenefitSelect(){
      let {extra_benefits_content={}} = this.formData||{}
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr||[]
    },
    option_benefits(){
      let {quote_coverage_list={}} = this.formData||{}
      let {more_benefit={}} = quote_coverage_list||{}
      let {sub_items={}} = more_benefit||{}
      let arr =[]
      if(sub_items){
        arr = Object.entries(sub_items).map(item=>item[1])
      }
      return arr
    },
    specialData(){
      let {quote_coverage_list} = this.formData||{}
      let {special_clause={}} = quote_coverage_list||{}
      return  special_clause||{}
    },
    specialList(){
      let { items=[]} = this.specialData||{}
      return items||[]
    },
    compareList(){
      let {type} = this.formData||{}
      let nowData = this.formData||{}
      let pre = this.preformData||{}
      if(type!=50)return []
      let arr =  Object.keys(nowData).reduce((result,key)=>{
        if(nowData[key]!=pre[key]){
          result.push(key)
        }
        return result
      },[])
      return arr||[]
    },
    sign_pic(){
      let {upload_document={},sign_pic={}} = this.formData
      let sign_data = sign_pic||{}
      if(this.productId==80){
        let {sign_files=[{}]} = upload_document||{}
        sign_data = sign_files[0]||{}
      }
      return sign_data.url
    },
    sidebarPremium() {
      let {quote_coverage_list={},type,sidebar_info} =this.formData||{}
      if(this.productId==80)
      {
        if(!sidebar_info){
          return []
        }
      }
      else {
        if(!quote_coverage_list) {
          return []
        }
      }
      let params = []
      let { premium=[]} =quote_coverage_list||{}
      let { premium_info=[]} =sidebar_info||{}
      params = this.productId==80?premium_info:premium
      return type==50?this.adjustPremium:params||[]
    },
    showAmount(){
      let arr = this.sidebarPremium||[]
      let obj = arr.find(item=>item.name == 'paid')||{}
      return obj.premium||''
    },
    extra_content_premium(){
      let {extra_benefits_content={}} = this.formData||{}
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr
    },
    extra_content_pcy(){
      let {extra_content_list={}} = this.formData||{}
      let arr =[]
      if(extra_content_list){
        arr = Object.entries(extra_content_list).map(item=>item[1])
      }
      return arr
    },
    classId() {
      return this.form.class_id || 14
    },
    localAllOptions() {
      if (this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`] || { mortgagor: [] }
      }
    },
    mortgagorOption() {
      // 拿status 為1的數據
      let { mortgagor=[] } = this.localAllOptions
      if(mortgagor.length) {
        mortgagor = mortgagor.filter(e=>e.status)
      }
      return mortgagor
    },
    isMortgagorOther(){
      let {mortgagor}=this.form
      let list = this.mortgagorOption.filter(item=>{
        return item.id==mortgagor
      })
      return list.length>0&&list[0].is_other==1?true:false
    },

  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        // Object.keys(this.formData).some(key => {
        //
        //   if (key in val) {
        //     this.formData[key] = JSON.parse(JSON.stringify(val[key]))
        //
        //   }
        // })
        this.formData = JSON.parse(JSON.stringify(val))
        let {upload_document = {}} = val
        let {br_files = []} = upload_document
        this.formData.br_files_type_pic = br_files[0]

        if (this.productId == 80) {
          let {upload_document = {}} = val
          let {br_files = []} = upload_document
          this.formData.upload_document = upload_document
          this.formData.br_files_type_pic = br_files[0]
        }
      }
    },
    specialOptions:{
      immediate: true,
      deep: true,
      handler(val){
        if(val.marketing_data){
          let arr = JSON.parse(JSON.stringify(val.marketing_data)) || []
          this.marketingList = arr
        }
      }
    },
  },
  methods:{
    getLocalAllOptionName(target, value) {
      if(this.classId == 14) {
        return this.getAllOptionName(target, value)
      } else {
        return this[`getAllOptionName${this.classId}`](target, value)
      }
    },
  }
}
</script>

<style scoped>

</style>
